module.exports = __webpack_public_path__ + "static/Lora-SemiBold-6c384a752b937ec93378fe87c2494234.ttf";